import { render, staticRenderFns } from "./open-banking-statements.vue?vue&type=template&id=369341cb"
import script from "./open-banking-statements.vue?vue&type=script&lang=js"
export * from "./open-banking-statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports